<template>
  <div class="ag-risco-legenda">
    <div class="ag-risco-legenda__item ag-risco-legenda__item--baixo">
      <div class="ag-risco-legenda__item-titulo">Baixo</div>
      <div class="ag-risco-legenda__item-descricao">
        Materialização do risco pequena, sendo apenas tratada como recomendação de melhoria no processo atual
      </div>
    </div>
    <div class="ag-risco-legenda__item ag-risco-legenda__item--moderado">
      <div class="ag-risco-legenda__item-titulo">Moderado</div>
      <div class="ag-risco-legenda__item-descricao">
        Sujeito a acionamento na Justiça do Trabalho, de forma individualizada por empregado, onde a análise é
        específica para cada situação
      </div>
    </div>
    <div class="ag-risco-legenda__item ag-risco-legenda__item--alto">
      <div class="ag-risco-legenda__item-titulo">Elevado</div>
      <div class="ag-risco-legenda__item-descricao">
        Materialização através de Fiscalizações e Auditorias, mediante a apresentação de documentos eletrônicos e
        físicos, sendo necessária uma análise mais detalhada para a identificação de evidências
      </div>
    </div>
    <div class="ag-risco-legenda__item ag-risco-legenda__item--critico">
      <div class="ag-risco-legenda__item-titulo">Crítico</div>
      <div class="ag-risco-legenda__item-descricao">
        Exposição imediata, através do cruzamento de dados eletrônicos transmitidos através do eSocial e outras
        obrigações acessórias que indica descumprimento da legislação vigente
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.ag-risco-legenda {
  font-size: $font-size-xxxs;
  width: 100%;

  .ag-risco-legenda__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-wrap: auto;
    border-left-width: $border-width-thick;
    border-left-style: $border-default;

    &--baixo {
      background-color: $feedback-color-success-light;
      border-left-color: $feedback-color-success-flourescent;
      color: $feedback-color-success-dark;
    }

    &--moderado {
      background-color: $feedback-color-attention-light;
      border-left-color: $feedback-color-attention-flourescent;
      color: $feedback-color-attention-dark;
    }

    &--alto {
      background-color: $feedback-color-more-attention-light;
      border-left-color: $feedback-color-more-attention-flourescent;
      color: $feedback-color-more-attention-dark;
    }

    &--critico {
      background-color: $feedback-color-error-light;
      border-left-color: $feedback-color-error-flourescent;
      color: $feedback-color-error-dark;
    }

    &:first-child {
      border-top-left-radius: $border-radius-sm;
      border-top-right-radius: $border-radius-sm;
    }

    &:last-child {
      border-bottom-left-radius: $border-radius-sm;
      border-bottom-right-radius: $border-radius-sm;
    }

    .ag-risco-legenda__item-titulo {
      font-weight: $font-weight-bold;
      border-radius: $border-radius-sm $border-radius-sm 0 0;
      padding: $spacing-05 $spacing-05 $spacing-05 $spacing-04;
      min-width: 92px;
    }

    .ag-risco-legenda__item-descricao {
      padding: $spacing-03 $spacing-03 $spacing-03 0;
      border-radius: 0 0 $border-radius-sm $border-radius-sm;
      hyphens: manual;
    }
  }
}
</style>
